const state = {
  categoryRemoved: '',
  hasMultipleInvalidExperiences: false,
  isInvalidPlayer: false,
  savingSpreadsheet: false,
};

const mutations = {
  setCategoryRemoved(state, categoryRemoved) {
    state.categoryRemoved = categoryRemoved;
  },
  setHasMultipleInvalidExperiences(state, hasMultiple) {
    state.hasMultipleInvalidExperiences = hasMultiple;
  },
  setSavingSpreadsheet(state, isSaving) {
    state.savingSpreadsheet = isSaving;
  },
  setIsInvalidPlayer(state, isInvalid) {
    state.isInvalidPlayer = isInvalid;
  },
};

const module = {
  mutations,
  state,
};

export default module;
